export default __webpack_public_path__ + "static/program-circle-repaired-en-c8d06efe578aff4fa7103f08b93dc13e.svg";